/*
 * Feel Awsm · Magnesium Balance Funnel
 * Shopify Dawn cart drawer integration (section-refresh pattern)
 * + scroll reveal + FAQ accordion + pricing toggle + nav hide/show + sticky cart
 * + Doctor Explains stat carousel
 */
(function () {
  'use strict';

  // Guard: prevent double-init if script is loaded by both top + bottom sections
  if (window.__feelawsmMgbInitialized) return;
  window.__feelawsmMgbInitialized = true;

  // Mark JS as ready — flips .mgb-reveal from "safe-visible" to "hidden, waiting to fade in"
  document.documentElement.classList.add('mgb-js');

  // ============ SCROLL REVEAL ============
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        revealObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.mgb-reveal').forEach(function (el) { revealObserver.observe(el); });

  // ============ FAQ ACCORDION ============
  document.querySelectorAll('.mgb-faq-item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      item.classList.toggle('mgb-open', item.open);
    });
  });

  // ============ PRICING TOGGLE (one-time / subscribe) ============
  var toggles = document.querySelectorAll('.mgb-toggle-btn');
  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      toggles.forEach(function (b) { b.classList.remove('mgb-active'); });
      btn.classList.add('mgb-active');
    });
  });

  // ============ NAV HIDE/SHOW + STICKY CART REVEAL ============
  var nav = document.getElementById('mgb-nav');
  var sticky = document.getElementById('mgb-sticky-cart');
  var lastY = 0;
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var y = window.scrollY;
      if (nav) {
        if (y > 100 && y > lastY) nav.classList.add('mgb-hidden');
        else nav.classList.remove('mgb-hidden');
        if (y > 20) nav.classList.add('mgb-scrolled');
        else nav.classList.remove('mgb-scrolled');
      }
      if (sticky) {
        if (y > 600) sticky.classList.add('mgb-show');
        else sticky.classList.remove('mgb-show');
      }
      lastY = y;
      ticking = false;
    });
  }, { passive: true });

  // ============ CART DRAWER INTEGRATION (Dawn pattern) ============
  function getCartUi() {
    return document.querySelector('cart-notification')
        || document.querySelector('cart-drawer');
  }

  function getCartAddUrl() {
    var cartAddPath = (typeof routes !== 'undefined' && routes.cart_add_url)
      ? String(routes.cart_add_url) : '/cart/add';
    if (cartAddPath.startsWith('/') && cartAddPath.indexOf('cart') !== -1) {
      return cartAddPath.replace(/\/cart\/add\/?$/, '/cart/add.js');
    }
    return '/cart/add.js';
  }

  function parseQuantity(btn) {
    var q = parseInt(btn.getAttribute('data-quantity'), 10);
    return (!Number.isNaN(q) && q > 0) ? q : 1;
  }

  // Fallback: if Shopify didn't return `sections` in /cart/add.js response
  // (happens for selling-plan items), fetch each drawer section via /cart?section_id=...
  function fetchSectionHtmlForCart(cart, data, doRender) {
    if (data.sections || !cart || typeof routes === 'undefined' || !routes.cart_url) {
      doRender(data);
      return Promise.resolve();
    }
    var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
    return Promise.all(sectionIds.map(function (id) {
      return fetch(routes.cart_url + '?section_id=' + id, { cache: 'no-store' })
        .then(function (r) { return r.text(); });
    })).then(function (htmls) {
      var sections = {};
      sectionIds.forEach(function (id, i) { sections[id] = htmls[i]; });
      doRender(Object.assign({}, data, { sections: sections }));
    }).catch(function () { doRender(data); });
  }

  document.querySelectorAll('.js-feelawsm-mgb-atc').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.getAttribute('aria-disabled') === 'true') return;

      var cart = getCartUi();
      var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
      var spRaw = btn.getAttribute('data-selling-plan') || '';
      var quantity = parseQuantity(btn);

      if (!vid || Number.isNaN(vid)) {
        console.warn('[feelawsm-mgb] Missing variant ID on ATC button');
        return;
      }

      var sellingPlanId = null;
      if (String(spRaw).trim() !== '') {
        var spNum = parseInt(spRaw, 10);
        if (!Number.isNaN(spNum)) sellingPlanId = spNum;
      }

      var item = { id: vid, quantity: quantity };
      if (sellingPlanId != null) item.selling_plan = sellingPlanId;
      var body = { items: [item] };

      if (cart) {
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
        // CRITICAL: request `sections` inline only for non-selling-plan items.
        // Selling plans fail when `sections` is in the body — Shopify quirk.
        if (sellingPlanId == null) {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
      }

      var addUrl = getCartAddUrl();
      var bodyString = JSON.stringify(body);
      var previousHtml = btn.innerHTML;
      btn.innerHTML = '';
      btn.appendChild(document.createTextNode('Adding...'));
      btn.classList.add('mgb-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('aria-disabled', 'true');

      // Selling plans → XHR; regular items → fetch (Shopify quirk)
      var cartAddPromise = sellingPlanId != null
        ? new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', addUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onload = function () {
              if (xhr.status < 200 || xhr.status >= 400) {
                reject(new Error('Cart add failed: ' + xhr.status));
                return;
              }
              try { resolve(JSON.parse(xhr.responseText)); }
              catch (e) { reject(e); }
            };
            xhr.onerror = function () { reject(new Error('Network error')); };
            xhr.send(bodyString);
          })
        : fetch(addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: bodyString,
          }).then(function (response) {
            if (!response.ok) throw new Error('Cart add failed: ' + response.status);
            return response.json();
          });

      cartAddPromise.then(function (response) {
        if (response.status) {
          // Shopify returned an error object (422, etc.)
          alert((response.description || response.message || 'Could not add to cart').toString());
          return;
        }

        // No drawer on page → hard redirect to /cart
        if (!cart) {
          window.location.href = (typeof routes !== 'undefined' && routes.cart_url)
            ? routes.cart_url : '/cart';
          return;
        }

        // Publish event for theme cart listeners
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          try {
            publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'feelawsm-mgb',
              productVariantId: String(vid),
              cartData: response,
            });
          } catch (e) { /* silent */ }
        }
        window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        var doRender = function (data) { cart.renderContents(data); };
        if (cart.classList && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
        return fetchSectionHtmlForCart(cart, response, doRender);
      }).catch(function (err) {
        console.warn('[feelawsm-mgb]', err);
        alert((err && err.message) || 'Could not add to cart');
      }).finally(function () {
        btn.innerHTML = previousHtml;
        btn.classList.remove('mgb-loading');
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('aria-disabled');
      });
    });
  });

  // ============ 3AM RISK CALCULATOR · V5 (understated luxury) ============
  var calc = document.querySelector('[data-mgb-calc]');
  if (calc) {
    var calcForm    = calc.querySelector('[data-calc-form]');
    var formScreen  = calc.querySelector('[data-form-screen]');
    var resultScreen= calc.querySelector('[data-result]');
    var ringWrap    = calc.querySelector('.mgb-calc-ring-wrap');
    var ringFill    = calc.querySelector('[data-ring-fill]');
    var scoreNumEl  = calc.querySelector('[data-score-num]');
    var scoreBandEl = calc.querySelector('[data-score-band]');
    var resultBodyEl= calc.querySelector('[data-result-body]');
    var retakeBtn   = calc.querySelector('[data-retake]');
    var pills       = calc.querySelectorAll('.mgb-calc-pill');

    var CIRC = 565.48;
    var answers = {};

    function determineBand(score) {
      if (score >= 70) return 'high';
      if (score >= 40) return 'moderate';
      return 'low';
    }

    pills.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.getAttribute('data-q');
        var value = parseInt(btn.getAttribute('data-value'), 10);
        var score = parseInt(btn.getAttribute('data-score'), 10);
        calc.querySelectorAll('.mgb-calc-pill[data-q="' + q + '"]').forEach(function (p) {
          p.classList.remove('mgb-selected');
        });
        btn.classList.add('mgb-selected');
        var parent = btn.closest('.mgb-calc-q');
        if (parent) parent.classList.remove('mgb-error');
        answers['q' + q] = { value: value, score: isNaN(score) ? 0 : score };
      });
    });

    function buildPersonalizedMessage(band) {
      var parts = [];
      var base = calc.getAttribute('data-base-' + band) || '';
      var fragments = [];
      if (answers.q3 && answers.q3.value >= 2) { var f1 = calc.getAttribute('data-pers-anxious'); if (f1) fragments.push(f1); }
      if (answers.q2 && answers.q2.value >= 2) { var f2 = calc.getAttribute('data-pers-cycle'); if (f2) fragments.push(f2); }
      if (answers.q5 && answers.q5.value >= 2) { var f3 = calc.getAttribute('data-pers-coffee'); if (f3) fragments.push(f3); }
      if (answers.q4 && answers.q4.value >= 3) { var f4 = calc.getAttribute('data-pers-stress'); if (f4) fragments.push(f4); }
      if (answers.q6 && answers.q6.value >= 2) { var f5 = calc.getAttribute('data-pers-age'); if (f5) fragments.push(f5); }
      fragments = fragments.slice(0, 2);
      parts.push('<p>' + base + '</p>');
      fragments.forEach(function (f) { parts.push('<p>' + f + '</p>'); });
      return parts.join('');
    }

    function animateScore(target) {
      var duration = 1400;
      var start = performance.now();
      function frame(now) {
        var p = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        if (scoreNumEl) scoreNumEl.textContent = Math.floor(target * eased);
        if (p < 1) requestAnimationFrame(frame);
        else if (scoreNumEl) scoreNumEl.textContent = String(target);
      }
      requestAnimationFrame(frame);
    }

    function animateRing(target) {
      if (!ringFill) return;
      var offset = CIRC * (1 - target / 100);
      ringFill.style.transition = 'none';
      ringFill.style.strokeDashoffset = CIRC;
      ringFill.getBoundingClientRect();
      requestAnimationFrame(function () {
        ringFill.style.transition = 'stroke-dashoffset 1.4s cubic-bezier(.25, 1, .3, 1)';
        ringFill.style.strokeDashoffset = String(offset);
      });
    }

    if (calcForm) {
      calcForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var missing = [];
        for (var i = 1; i <= 6; i++) { if (!answers['q' + i]) missing.push(i); }
        if (missing.length) {
          missing.forEach(function (n) {
            var q = calc.querySelectorAll('.mgb-calc-q')[n - 1];
            if (q) q.classList.add('mgb-error');
          });
          var firstMissing = calc.querySelectorAll('.mgb-calc-q')[missing[0] - 1];
          if (firstMissing) firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var score = 0;
        Object.keys(answers).forEach(function (k) { score += answers[k].score || 0; });
        if (score > 100) score = 100;
        var band = determineBand(score);
        var bandLabel = calc.getAttribute('data-label-' + band) || '';
        if (ringWrap) ringWrap.setAttribute('data-band', band);
        if (scoreBandEl) {
          scoreBandEl.setAttribute('data-band', band);
          scoreBandEl.textContent = bandLabel;
        }
        if (resultBodyEl) resultBodyEl.innerHTML = buildPersonalizedMessage(band);
        if (formScreen) formScreen.hidden = true;
        if (resultScreen) resultScreen.hidden = false;
        if (scoreNumEl) scoreNumEl.textContent = '0';
        animateScore(score);
        animateRing(score);
        setTimeout(function () { resultScreen.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 100);
      });
    }

    if (retakeBtn) {
      retakeBtn.addEventListener('click', function () {
        answers = {};
        calc.querySelectorAll('.mgb-calc-pill.mgb-selected').forEach(function (b) { b.classList.remove('mgb-selected'); });
        calc.querySelectorAll('.mgb-calc-q.mgb-error').forEach(function (q) { q.classList.remove('mgb-error'); });
        if (ringFill) {
          ringFill.style.transition = 'none';
          ringFill.style.strokeDashoffset = CIRC;
        }
        if (resultScreen) resultScreen.hidden = true;
        if (formScreen) formScreen.hidden = false;
        calc.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  // ============ DOCTOR EXPLAINS · STAT CAROUSEL ============
  var carousel = document.querySelector('.mgb-doctor-stats');
  if (carousel) {
    var track      = carousel.querySelector('.mgb-doctor-stats-track');
    var prevBtn    = carousel.querySelector('.mgb-doctor-stats-prev');
    var nextBtn    = carousel.querySelector('.mgb-doctor-stats-next');
    var currentEl  = carousel.querySelector('.mgb-doctor-stats-current');
    var totalEl    = carousel.querySelector('.mgb-doctor-stats-total');
    var fillEl     = carousel.querySelector('.mgb-doctor-stats-fill');
    var dots       = Array.from(carousel.querySelectorAll('.mgb-doctor-stats-dot'));

    if (track) {
      var total = parseInt(track.dataset.statsCount, 10) || 4;
      var idx = 0;
      var autoTimer = null;

      function render() {
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        if (currentEl) currentEl.textContent = String(idx + 1);
        if (totalEl)   totalEl.textContent   = String(total);
        if (fillEl)    fillEl.style.width    = (((idx + 1) / total) * 100) + '%';
        dots.forEach(function (d, i) { d.classList.toggle('mgb-active', i === idx); });
        if (prevBtn) prevBtn.disabled = idx === 0;
        if (nextBtn) nextBtn.disabled = idx === total - 1;
      }
      function go(n) { idx = (n + total) % total; render(); }
      function startAuto() {
        stopAuto();
        autoTimer = setInterval(function () { go((idx + 1) % total); }, 6000);
      }
      function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
      function resetAuto() { stopAuto(); startAuto(); }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); resetAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); resetAuto(); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); resetAuto(); }); });

      // Touch swipe on mobile
      var touchStartX = 0;
      carousel.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      carousel.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) {
          if (dx < 0 && idx < total - 1) go(idx + 1);
          if (dx > 0 && idx > 0) go(idx - 1);
          resetAuto();
        }
      }, { passive: true });

      carousel.addEventListener('mouseenter', stopAuto);
      carousel.addEventListener('mouseleave', startAuto);
      carousel.addEventListener('focusin',    stopAuto);
      carousel.addEventListener('focusout',   startAuto);

      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { startAuto(); vio.disconnect(); } });
      }, { threshold: 0.3 });
      vio.observe(carousel);

      render();
    }
  }
})();
